import { ICreateSlip } from "../interfaces/slips";
import { privateApi, privateApiWithBlob } from "./axios";

export const getSlips = async () => {
    try {
        const response = await privateApi.get("api/slips")
        return response
    } catch (error) {
        throw error
    }
};

export const createSlips = async (data: ICreateSlip) => {
    try {
        const response = await privateApi.post("api/slips", data)
        return response
    } catch (error) {
        throw error
    }
}

export const downloadSlip = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/slips/${id}/document`, {
            responseType: "blob",
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const downloadExportSage = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/slips/report?startDate=${startDate}&endDate=${endDate}`, {
            responseType: "blob",
        })
        return response
    } catch (error) {
        throw error
    }
}
